import { Routes } from '@angular/router';
import {AuthGuard} from '@auth0/auth0-angular';;
import { CarrierImportVerificationToolComponent } from './verification-tool/carrier-import-verification-tool.component';
import { ManageCarrierImportGuard } from '../core/guards/manage-carrier-import.guard';

export const CARRIER_IMPORT_ROUTES: Routes = [
  {
    path: 'carrier-import',
    data: { loadHandoversView: true },
    component: CarrierImportVerificationToolComponent,
    canActivate: [AuthGuard, ManageCarrierImportGuard],
    children: [
      { path: 'verification-tool', component: CarrierImportVerificationToolComponent },
      { path: '**', redirectTo: '' }
    ]
  }
];
